import { render, staticRenderFns } from "./attendance-summary.vue?vue&type=template&id=897175be&"
import script from "./attendance-summary.vue?vue&type=script&lang=js&"
export * from "./attendance-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports